module.exports = __webpack_public_path__ + "img/check-circle.58b57158.svg";